import {cn} from "@/utils/cn.ts";
import styles from "@/pages/Refund/RefundPage.module.scss";
import {useState} from "react";
import {Detail} from "../types.ts";
import axios from "axios";
import {API_URL} from "@/config.tsx";
import {useNavigate} from "react-router-dom";

/**
 * Блок возврата товара надлежащего качества
 * @constructor
 */
export const QualityRefund = () => {
    const [orderNumber, setOrderNumber] = useState<string>('');
    const [carInfo, setCarInfo] = useState<string>('');
    const [customerName, setCustomerName] = useState<string>('');
    const [customerPhone, setCustomerPhone] = useState<string>('');
    const [details, setDetails] = useState<Detail[]>([]);
    const [detailName, setDetailName] = useState<string>('');
    const [detailQuantity, setDetailQuantity] = useState<number>(1);
    const [detailRefundReason, setDetailRefundReason] = useState<string>('');
    const [disabled, setDisabled] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    /** Проверка параметров ввода информации о детале */
    const checkDetail = () => {
        if (!detailRefundReason.trim()) {
            alert('Не указана причина возврата детали!');
            return false;
        }

        if (!detailName.trim()) {
            alert('Не указана маркировка детали!');
            return false;
        }

        //Сброс блокировки отправки
        if (disabled) {
            setDisabled(false);
        }

        return true;
    };

    /** Проверка параметров ввода данных о заказе */
    const checkOrder = () => {
        if (!orderNumber.trim() || orderNumber.trim().length < 6) {
            alert('Номер заказа указан некорректно!');
            return false;
        }

        if (!carInfo.trim()) {
            alert('Не указан номер кузова / рамы!');
            return false;
        }

        if (!customerName.trim()) {
            alert('Не указано имя!');
            return false;
        }

        if (!customerPhone.trim() || customerPhone.trim().length < 10) {
            alert('Не указан телефон!');
            return false;
        }

        if (!details.length) {
            alert('Не указаны возвращаемые детали');
            return false;
        }

        return true;
    };

    /** Добавление детали */
    const addDetail = () => {
        if (checkDetail()) {
            setDetails([...details, {
                detailName,
                detailQuantity,
                detailRefundReason
            }]);

            setDetailName('');
            setDetailQuantity(1);
            setDetailRefundReason('');
        }
    };

    /** Отправка формы */
    const goodQualityOnSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (checkOrder()) {
            const formData = new FormData();

            formData.append('orderNumber', orderNumber);
            formData.append('carInfo', carInfo);
            formData.append('customerName', customerName);
            formData.append('customerPhone', customerPhone);

            details.forEach((detail, index) => {
                formData.append(`detailName[${index}]`, detail.detailName);
                formData.append(`detailQuantity[${index}]`, detail.detailQuantity.toString());
                formData.append(`detailRefundReason[${index}]`, detail.detailRefundReason);
            });

            newRefoundQualityRequest(formData);
        }
    };

    /** Отправка заявки на возврат */
    const newRefoundQualityRequest = (formData: FormData) => {
        setIsLoading(true);
        setDisabled(true);
        axios.post(`${API_URL}/refund_quality`, formData, {withCredentials: true})
            .then(response => response.data)
            .then(data => {
                if (data?.success) {
                    setDetails([]);
                    setOrderNumber('');
                    alert("Запрос успешно отправлен!");
                    navigate('/profile/refund_requests');
                }
            })
            .catch(error => {
                console.error(error.message);
                setDisabled(false);
            })
            .finally(() => setIsLoading(false));
    };

    return (
        <>
            <h4>Возврат автозапчастей, надлежащего качества:</h4>
            <ul>
                <li> товар не имеет следов установки;</li>
                <li> не нарушена упаковка;</li>
                <li> сохранён товарный вид;</li>
                <li> сохранены потребительские свойства товара;</li>
                <li> сохранены фабричные ярлыки;</li>
                <li> прошло не более 7 (семи) дней после получения товара (при условии предоставления подтверждающего
                    документа), не считая дня его покупки, при дистанционном способе продажи;
                </li>
                <li> прошло не более 14 (четырнадцати) дней при приобретение товара самовывозом из офисов компании.</li>
            </ul>
            <div>
                При отказе от товара надлежащего качества Продавец удерживает денежную сумму, за возврат товара на
                доставку от потребителя возвращенного товара, не позднее чем через десять дней со дня предъявления
                потребителем соответствующего требования.
            </div>
            <div className="primary-color" style={{marginTop: '10px'}}>
                Заполните, пожалуйста, все поля заявки и мы ответим в течении 1-2 рабочих дней.
            </div>
            <form method="post"
                  className={cn("refund-form", styles.form)}
                  id="refundForm"
                  encType="multipart/form-data"
                  onSubmit={goodQualityOnSubmit}>
                <div className="refund-form-row">
                    <div className="refund-input-block"><input autoComplete="off" className="refund-input-text"
                                                               name="orderNumber" id="orderNumber"
                                                               placeholder="Номер заказа" type="text"
                                                               value={orderNumber}
                                                               onChange={(e) => setOrderNumber(e.target.value)}/></div>
                    <div className="refund-input-block"><input autoComplete="off" className="refund-input-text"
                                                               name="carInfo" id="carInfo"
                                                               placeholder="Номер кузова / рамы" type="text"
                                                               value={carInfo}
                                                               onChange={(e) => setCarInfo(e.target.value)}/></div>
                    <div className="refund-input-block"><input autoComplete="off" className="refund-input-text"
                                                               name="customerName" id="customerName" placeholder="Имя"
                                                               type="text" value={customerName}
                                                               onChange={(e) => setCustomerName(e.target.value)}/></div>
                    <div className="refund-input-block"><input autoComplete="off" className="refund-input-text"
                                                               name="customerPhone" id="customerPhone"
                                                               placeholder="Телефон" type="tel" value={customerPhone}
                                                               onChange={(e) => setCustomerPhone(e.target.value)}/>
                    </div>
                </div>
                <div className="refund-form-row" id="details">
                    <div className="refund-detail-row">
                        <div className="detail-separator"></div>
                        <div className="refund-detail-block">
                            <div className="refund-detail-block-row"><input autoComplete="off"
                                                                            className="refund-input-text"
                                                                            id="detailName1" name="detailName[0]"
                                                                            placeholder="Маркировка детали" type="text"
                                                                            value={detailName}
                                                                            onChange={(e) => setDetailName(e.target.value)}/>
                            </div>
                            <div className="refund-detail-block-row"><input autoComplete="off"
                                                                            className="refund-input-text"
                                                                            name="detailQuantity[0]"
                                                                            placeholder="Кол-во" type="number" min="1"
                                                                            value={detailQuantity}
                                                                            onChange={(e) => setDetailQuantity(Number(e.target.value))}/>
                            </div>
                        </div>
                        <div className="refund-detail-action-block">
                            <div className="refund-detail-action-block-row"><textarea rows={2} autoComplete="off"
                                                                                      className="refund-input-text"
                                                                                      id="detailRefundReason1"
                                                                                      name="detailRefundReason[0]"
                                                                                      placeholder="Причина возврата"
                                                                                      value={detailRefundReason}
                                                                                      onChange={(e) => setDetailRefundReason(e.target.value)}></textarea>
                            </div>
                            <button className="refund-input-button" type="button" onClick={addDetail}>Добавить деталь
                                +
                            </button>
                        </div>
                    </div>
                </div>
                <div className="detail-separator"></div>
                <div className="refund-form-row">
                    <div className="refund-detail-action-block">
                        <div className="refund-detail-action-block-row">
                            <ul>
                                {details.map((detail, index) =>
                                    <li key={index}>{detail.detailName} ({detail.detailQuantity} шт.)</li>
                                )}
                            </ul>
                        </div>
                        <button className={cn("refund-input-button", styles.submitBtn, disabled && styles.submitBtn__disabled)}
                                id="sendFormButton"
                                type="submit"
                                disabled={disabled}>
                            {!isLoading ? 'Отправить' : 'Отправка...'}
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
};
